// @flow
import React, { Component } from "react";
import get from "lodash/get";
import find from "lodash/find";
import { withGlobalContext } from "../../common/GlobalContext";

import FullWidthBgWithSearch from "./FullWidthBgWithSearch";
import CollapsedSearch from "./CollapsedSearch";
import FullWidthBgSearchBar from "./FullWidthBgSearchBar";
import StackedNameSearch from "./StackedNameSearch";
import BackgroundTransparentSearch from "./BackgroundTransparentSearch";
import ThreeButton from "./ThreeButton";
import ExpandedSearchHalf from "./ExpandedSearchHalf";

import type { $Site } from "flow/types";

type $Props = {
  site: $Site,
  homepageSearchHeroImage: string,
  homepageHeroImages: Array<string>,
};

type $State = {
  backgroundImage: string,
  homepageHeroImages?: Array<string>,
};

class CoverPods extends Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);
    this.state = {
      backgroundImage: "",
      homepageHeroImages: [],
    };
  }

  // Lazy loads the background image passed to the coverpod
  componentDidMount() {
    const { homepageSearchHeroImage, homepageHeroImages } = this.props;
    const imageLoader = new Image();
    imageLoader.src = `${homepageSearchHeroImage}`;
    imageLoader.onload = () => {
      this.setState({ backgroundImage: homepageSearchHeroImage });
      this.setState({ homepageHeroImages });
    };
  }

  render() {
    const { site, homepageHeroImages } = this.props;
    const { backgroundImage } = this.state;
    const { pods } = site.uiConfig;
    const coverPod = get(find(pods, { section: "homepageCover" }), "value");
    if (!coverPod) {
      return <div />;
    }
    switch (coverPod) {
      case "fullWidthBackgroundSearchInside":
        return (
          <FullWidthBgWithSearch
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "collapsedSearchCenterFull":
        return (
          <CollapsedSearch
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "fullWidthBackgroundImageAndBlackSearch":
      case "fullWidthBackgroundBlackSearch":
      case "fullWidthBackgroundCutoutAndName":
        return (
          <FullWidthBgSearchBar
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "backgroundWithStackedPhotoNameAndSearch":
        return (
          <StackedNameSearch
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "backgroundImageAndTransparentSearch":
        return (
          <BackgroundTransparentSearch
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "backgroundImageThreeButtons":
        return (
          <ThreeButton
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      case "expandedSearchHalf":
        return (
          <ExpandedSearchHalf
            backgroundImage={backgroundImage}
            backgroundImages={homepageHeroImages}
          />
        );
      default:
        return <div />;
    }
  }
}

export default withGlobalContext(CoverPods);
